import { SideEffectSchema, loadingAction, errorAction, successSideEffectState, generateConst, APIErrorResponseSchema, ObjectSchema } from ".";
import { LanguageSchema } from "../../i18n";

export const IntegrationsConst = generateConst("INTEGRATIONS", [
  "GET_DATA_EXPORT_DUMP_REQUESTS",
  "REMOVE_DATA_EXPORT_DUMP_REQUEST",
  "ADD_DATA_EXPORT_DUMP_REQUEST",
  "GET_EXPORT_LOGS",
  "GET_EXPORT_LOG_DOWNLOAD_URL",
  "GET_WEB_HOOK_REQUESTS",
  "DELETE_WEB_HOOK",
  "ADD_WEB_HOOK",
  "UPDATE_WEB_HOOK",
  "GET_WEB_HOOK_QUOTA",
  "SET_DEFAULT_QUOTA",
  "GET_AVAILABLE_INTEGRATIONS",
  "GET_INTEGRATION_LIST",
  "GET_INTEGRATION_SUBSCRIPTIONS",
  "ACTIVATE_INTEGRATION",
  "DEACTIVATE_INTEGRATION",
  "GET_INTEGRATION_CONFIG",
  "SAVE_INTEGRATION_DATA",
  "GET_AUDIT_LOG_DATA",
  "SAVE_AUDIT_LOG_DATA",
  "UPDATE_AUDIT_LOG_DATA",
  "DELETE_AUDIT_LOG_DATA",
  "GET_WEBHOOK_EVENTS",
  "GET_AUDIT_LOG_LIMITS"
]);

export interface DataExportDumpRequestSchema {
  Id: string;
  Type: string;
  StartDate?: string;
  EndDate?: string;
  IsDone: boolean;
  IsRunning: boolean;
  Frequency?: string;
  Emails: string[];
  Name: string;
}

export interface GetDataExportDumpRequestsResponseSchema {
  Data: DataExportDumpRequestSchema[];
  Description?: string;
  ErrorCode?: number;
  Message?: string;
  clientIP: string;
  lrmessage?: string;
}

export interface GetDataExportDumpRequestsDataSchema extends SideEffectSchema {
  response: GetDataExportDumpRequestsResponseSchema;
}

export const getDataExportDumpRequestsAction = () => {
  return {
    type: IntegrationsConst.GET_DATA_EXPORT_DUMP_REQUESTS,
    payload: {}
  };
};

export const getDataExportDumpRequestsLoadingAction = () => loadingAction(IntegrationsConst.GET_DATA_EXPORT_DUMP_REQUESTS_LOADING);

export const getDataExportDumpRequestsSuccessAction = (data: GetDataExportDumpRequestsDataSchema) => {
  const payload = { ...data, ...successSideEffectState };
  return {
    type: IntegrationsConst.GET_DATA_EXPORT_DUMP_REQUESTS_SUCCESS,
    payload
  };
};

export const getDataExportDumpRequestsErrorAction = (error: string) => errorAction(IntegrationsConst.GET_DATA_EXPORT_DUMP_REQUESTS_ERROR, error);

export interface RemoveDataExportDumpRequestResponseSchema {
  clientIP: string;
  isdeleted: boolean;
  Description?: string;
  ErrorCode?: string;
  Message?: string;
}

export interface RemoveDataExportDumpRequestDataSchema extends SideEffectSchema {
  response: RemoveDataExportDumpRequestResponseSchema;
}

export const removeDataExportDumpRequestAction = (dataExportRequestId: string) => {
  return {
    type: IntegrationsConst.REMOVE_DATA_EXPORT_DUMP_REQUEST,
    payload: { dataExportRequestId }
  };
};

export const removeDataExportDumpRequestLoadingAction = () => loadingAction(IntegrationsConst.REMOVE_DATA_EXPORT_DUMP_REQUEST_LOADING);

export const removeDataExportDumpRequestSuccessAction = (data: RemoveDataExportDumpRequestDataSchema) => {
  const payload = { ...data, ...successSideEffectState };
  return {
    type: IntegrationsConst.REMOVE_DATA_EXPORT_DUMP_REQUEST_SUCCESS,
    payload
  };
};

export const removeDataExportDumpRequestErrorAction = (error: string) => errorAction(IntegrationsConst.REMOVE_DATA_EXPORT_DUMP_REQUEST_ERROR, error);

export interface DataExportRequestSchema {
  EndDate?: string;
  StartDate?: string;
  Type: string;
  Frequency: string;
  ScheduleRunTime?: number;
  ScheduleWeekDay?: string;
  ScheduleMonthDate: number;
  Emails: string[];
  FilteredQuery?: string;
  SelectedFields: string[];
  ExportDataFormat: string;
  Comment: string;
  FileEncryptionKey: string | number;
}

export const addDataExportDumpRequestAction = (dataExportRequest: DataExportRequestSchema) => {
  return {
    type: IntegrationsConst.ADD_DATA_EXPORT_DUMP_REQUEST,
    payload: { dataExportRequest }
  };
};

export const addDataExportDumpRequestLoadingAction = () => loadingAction(IntegrationsConst.ADD_DATA_EXPORT_DUMP_REQUEST_LOADING);

export const addDataExportDumpRequestSuccessAction = (data: GetDataExportDumpRequestsDataSchema) => {
  const payload = { ...data, ...successSideEffectState };
  return {
    type: IntegrationsConst.ADD_DATA_EXPORT_DUMP_REQUEST_SUCCESS,
    payload
  };
};

export const addDataExportDumpRequestErrorAction = (error: string) => errorAction(IntegrationsConst.ADD_DATA_EXPORT_DUMP_REQUEST_ERROR, error);

export interface ExportLogSchema {
  DumpDataDownloadLink: string;
  DumpDemandRequestId: string;
  EndTime: string;
  ErrorMessage: string;
  StartTime: string;
  Status: number;
}

export interface GetExportLogsSchema extends SideEffectSchema {
  Data?: ExportLogSchema[];
  ErrorCode?: number;
  Message?: string;
  Description?: string;
}

export const getExportLogsAction = () => {
  return {
    type: IntegrationsConst.GET_EXPORT_LOGS,
    payload: {}
  };
};

export const getExportLogsLoadingAction = () => loadingAction(IntegrationsConst.GET_EXPORT_LOGS_LOADING);

export const getExportLogsSuccessAction = (data: GetExportLogsSchema) => {
  const payload = { ...data, ...successSideEffectState };
  return {
    type: IntegrationsConst.GET_EXPORT_LOGS_SUCCESS,
    payload
  };
};

export const getExportLogsErrorAction = (error: string) => errorAction(IntegrationsConst.GET_EXPORT_LOGS_ERROR, error);

export interface GetExportLogDownloadUrlSchema extends SideEffectSchema {
  Data?: {
    downloadUrl: string;
  };
  ErrorCode?: number;
  Message?: string;
  Description?: string;
}

export const getExportLogDownloadUrlAction = (s3Path: string) => {
  return {
    type: IntegrationsConst.GET_EXPORT_LOG_DOWNLOAD_URL,
    payload: { s3Path }
  };
};

export const getExportLogDownloadUrlLoadingAction = () => loadingAction(IntegrationsConst.GET_EXPORT_LOG_DOWNLOAD_URL_LOADING);

export const getExportLogDownloadUrlSuccessAction = (data: GetExportLogDownloadUrlSchema) => {
  const payload = { ...data, ...successSideEffectState };
  return {
    type: IntegrationsConst.GET_EXPORT_LOG_DOWNLOAD_URL_SUCCESS,
    payload
  };
};

export const getExportLogDownloadUrlErrorAction = (error: string) => errorAction(IntegrationsConst.GET_EXPORT_LOG_DOWNLOAD_URL_ERROR, error);

export interface WebHookRequestSchema {
  Data?: any[];
}

export interface GetWebHookRequestsSchema extends SideEffectSchema {
  Data?: any[];
}

export interface GetWebhookEventsSchema extends SideEffectSchema {
  Data?: any[];
}

export const getWebHookRequestsAction = () => {
  return {
    type: IntegrationsConst.GET_WEB_HOOK_REQUESTS,
    payload: {}
  };
};

export const getWebhookEventsAction = () => {
  return {
    type: IntegrationsConst.GET_WEBHOOK_EVENTS,
    payload: {}
  };
};

export const getWebhookEventsLoadingAction = () => loadingAction(IntegrationsConst.GET_WEBHOOK_EVENTS_LOADING);

export const getWebhookEventsSuccessAction = (data: GetWebhookEventsSchema) => {
  const payload = { ...data, ...successSideEffectState };
  return {
    type: IntegrationsConst.GET_WEBHOOK_EVENTS_SUCCESS,
    payload
  };
};

export const getWebhookEventsErrorAction = (error: string) => errorAction(IntegrationsConst.GET_WEBHOOK_EVENTS_ERROR, error);

export const getAuditLogConfigAction = () => {
  return {
    type: IntegrationsConst.GET_AUDIT_LOG_DATA,
    payload: {}
  };
};

export const getAuditLogConfigLoadingAction = () => loadingAction(IntegrationsConst.GET_AUDIT_LOG_DATA_LOADING);

export const getAuditLogConfigSuccessAction = (data: AuditLogConfigResponseSchema[]) => {
  const payload = { data, ...successSideEffectState };
  return {
    type: IntegrationsConst.GET_AUDIT_LOG_DATA_SUCCESS,
    payload
  };
};

export const getAuditLogConfigErrorAction = (error: string) => errorAction(IntegrationsConst.GET_AUDIT_LOG_DATA_ERROR, error);

export const getWebHookRequestsLoadingAction = () => loadingAction(IntegrationsConst.GET_WEB_HOOK_REQUESTS_LOADING);

export const getWebHookRequestsSuccessAction = (data: GetWebHookRequestsSchema) => {
  const payload = { ...data, ...successSideEffectState };
  return {
    type: IntegrationsConst.GET_WEB_HOOK_REQUESTS_SUCCESS,
    payload
  };
};

export const getWebHookRequestsErrorAction = (error: string) => errorAction(IntegrationsConst.GET_WEB_HOOK_REQUESTS_ERROR, error);

export interface DeleteWebHookResponseSchema extends SideEffectSchema {
  IsDeleted?: boolean;
}

export interface DeleteWebhookRequestSchema {
  HookId: string;
}

export const deleteWebHookAction = (payload: DeleteWebhookRequestSchema) => {
  return {
    type: IntegrationsConst.DELETE_WEB_HOOK,
    payload
  };
};

export const deleteWebHookLoadingAction = () => loadingAction(IntegrationsConst.DELETE_WEB_HOOK_LOADING);

export const deleteWebHookSuccessAction = (data: DeleteWebHookResponseSchema) => {
  const payload = { ...data, ...successSideEffectState };
  return {
    type: IntegrationsConst.DELETE_WEB_HOOK_SUCCESS,
    payload
  };
};

export const deleteWebHookErrorAction = (error: string) => errorAction(IntegrationsConst.DELETE_WEB_HOOK_ERROR, error);

export interface AddWebHookResponseSchema extends SideEffectSchema {
  IsPosted?: boolean;
}

export interface AddWebhookRequestSchema {
  name: string;
  event: string;
  targeturl: string;
  secretname: string;
}
export const saveAuditLogConfigAction = (payload: AuditLogBodySchema) => {
  return {
    type: IntegrationsConst.SAVE_AUDIT_LOG_DATA,
    payload
  };
};
export const saveAuditLogConfigLoadingAction = () => loadingAction(IntegrationsConst.SAVE_AUDIT_LOG_DATA_LOADING);

export const saveAuditLogConfigSuccessAction = (data: AddWebHookResponseSchema) => {
  const payload = { ...data, ...successSideEffectState };
  return {
    type: IntegrationsConst.SAVE_AUDIT_LOG_DATA_SUCCESS,
    payload
  };
};

export const saveAuditLogConfigErrorAction = (error: string) => errorAction(IntegrationsConst.SAVE_AUDIT_LOG_DATA_ERROR, error);

export const updateAuditLogConfigAction = (id: string, payload: AuditLogBodySchema) => {
  return {
    type: IntegrationsConst.UPDATE_AUDIT_LOG_DATA,
    payload: { id, ...payload }
  };
};
export const updateAuditLogConfigLoadingAction = () => loadingAction(IntegrationsConst.UPDATE_AUDIT_LOG_DATA_LOADING);
export const updateAuditLogConfigSuccessAction = (data: SaveAuditLogConfigSchema) => {
  const payload = { ...data, ...successSideEffectState };
  return {
    type: IntegrationsConst.UPDATE_AUDIT_LOG_DATA_SUCCESS,
    payload
  };
};
export const updateAuditLogConfigErrorAction = (error: string) => errorAction(IntegrationsConst.UPDATE_AUDIT_LOG_DATA_ERROR, error);

export const resetAuditLogConfigAction = (id: string) => {
  return {
    type: IntegrationsConst.DELETE_AUDIT_LOG_DATA,
    payload: { id }
  };
};
export const resetAuditLogConfigLoadingAction = () => loadingAction(IntegrationsConst.DELETE_AUDIT_LOG_DATA_LOADING);

export const resetAuditLogConfigSuccessAction = (data: ResetAuditLogConfigSchema) => {
  const payload = { ...data, ...successSideEffectState };
  return {
    type: IntegrationsConst.DELETE_AUDIT_LOG_DATA_SUCCESS,
    payload
  };
};

export const resetAuditLogConfigErrorAction = (error: string) => errorAction(IntegrationsConst.DELETE_AUDIT_LOG_DATA_ERROR, error);

export const addWebHookAction = (payload: AddWebhookRequestSchema) => {
  return {
    type: IntegrationsConst.ADD_WEB_HOOK,
    payload
  };
};

export const addWebHookLoadingAction = () => loadingAction(IntegrationsConst.ADD_WEB_HOOK_LOADING);

export const addWebHookSuccessAction = (data: AddWebHookResponseSchema) => {
  const payload = { ...data, ...successSideEffectState };
  return {
    type: IntegrationsConst.ADD_WEB_HOOK_SUCCESS,
    payload
  };
};

export const addWebHookErrorAction = (error: string) => errorAction(IntegrationsConst.ADD_WEB_HOOK_ERROR, error);

export interface UpdateWebHookResponseSchema extends SideEffectSchema {
  IsPosted?: boolean;
}

export interface UpdateWebhookRequestSchema {
  CustomObjects: string;
  HookId: string;
  SecretName: string;
}

export const updateWebHookAction = (payload: UpdateWebhookRequestSchema, i18n: LanguageSchema) => {
  return {
    type: IntegrationsConst.UPDATE_WEB_HOOK,
    payload,
    i18n
  };
};

export const updateWebHookLoadingAction = () => loadingAction(IntegrationsConst.UPDATE_WEB_HOOK_LOADING);

export const updateWebHookSuccessAction = (data: UpdateWebHookResponseSchema) => {
  const payload = { ...data, ...successSideEffectState };
  return {
    type: IntegrationsConst.UPDATE_WEB_HOOK_SUCCESS,
    payload
  };
};

export const updateWebHookErrorAction = (error: string) => errorAction(IntegrationsConst.UPDATE_WEB_HOOK_ERROR, error);

/**
 * GET_AVAILABLE_INTEGRATIONS
 */
export interface AvailableIntegrationsSchema extends SideEffectSchema, APIErrorResponseSchema {
  AuthorizedIntegrations: string[];
}

export const getAvailableIntegrationsAction = () => {
  return {
    type: IntegrationsConst.GET_AVAILABLE_INTEGRATIONS
  };
};

export const getAvailableIntegrationsLoadingAction = () => loadingAction(IntegrationsConst.GET_AVAILABLE_INTEGRATIONS_LOADING);

export const getAvailableIntegrationsErrorAction = (error: string) => errorAction(IntegrationsConst.GET_AVAILABLE_INTEGRATIONS_ERROR, error);

export const getAvailableIntegrationsSuccessAction = (data: AvailableIntegrationsSchema) => {
  const payload = { ...data, ...successSideEffectState };
  return {
    type: IntegrationsConst.GET_AVAILABLE_INTEGRATIONS_SUCCESS,
    payload
  };
};

/**
 * GET_INTEGRATION_SUBSCRIPTIONS
 */
export interface IntegrationSubscription {
  Id: string;
  Name: string;
  Event: string;
  Description?: string | null;
  Label?: string | null;
  Credentials?: Record<string, string>;
  Meta?: Record<string, string>;
  IsCustom: boolean;
  IsActive: boolean;
  IsEnable: boolean;
  IsConfigurable: boolean;
  PluginFilters?: object[];
  Mapping?: { map?: unknown };
  DownwardMapping?: Record<string, string>;
  Script?: string | null;
  Filter?: object[];
}

export interface IntegrationSubscriptionsSchema extends SideEffectSchema, APIErrorResponseSchema {
  Data: IntegrationSubscription[];
}

export const getIntegrationSubscriptionsAction = () => ({
  type: IntegrationsConst.GET_INTEGRATION_SUBSCRIPTIONS
});

export const getIntegrationSubscriptionsLoadingAction = () => loadingAction(IntegrationsConst.GET_INTEGRATION_SUBSCRIPTIONS_LOADING);

export const getIntegrationSubscriptionsErrorAction = (error: string) => errorAction(IntegrationsConst.GET_INTEGRATION_SUBSCRIPTIONS_ERROR, error);

export const getIntegrationSubscriptionsSuccessAction = (data: IntegrationSubscriptionsSchema) => {
  const payload = { ...data, ...successSideEffectState };
  return {
    type: IntegrationsConst.GET_INTEGRATION_SUBSCRIPTIONS_SUCCESS,
    payload
  };
};

/**
 * ACTIVATE_INTEGRATION
 */
export interface ActivateIntegrationSchema extends SideEffectSchema {
  data: any;
  id?: string;
}
export interface ActivateIntegrationArgs {
  Event: string;
  IntegrationName: string;
  id: string;
  isEnable: boolean;
}
export const activateIntegrationAction = (payload: ActivateIntegrationArgs) => {
  return {
    type: IntegrationsConst.ACTIVATE_INTEGRATION,
    payload
  };
};

export const activateIntegrationLoadingAction = (id: string) => loadingAction(IntegrationsConst.ACTIVATE_INTEGRATION_LOADING, { id });

export const activateIntegrationErrorAction = (error: string) =>
  errorAction(IntegrationsConst.ACTIVATE_INTEGRATION_ERROR, error, {
    id: undefined
  });

export const activateIntegrationSuccessAction = (data: ActivateIntegrationSchema) => {
  const payload = { ...data, id: undefined, ...successSideEffectState };
  return {
    type: IntegrationsConst.ACTIVATE_INTEGRATION_SUCCESS,
    payload
  };
};

/**
 * DEACTIVATE_INTEGRATION
 */
export interface DeactivateIntegrationSchema extends SideEffectSchema, APIErrorResponseSchema {
  isdeleted: boolean;
  id?: string;
}
export interface DeactivateIntegrationArgs {
  integrationId: string;
}
export const deactivateIntegrationAction = (payload: DeactivateIntegrationArgs) => {
  return {
    type: IntegrationsConst.DEACTIVATE_INTEGRATION,
    payload
  };
};

export const deactivateIntegrationLoadingAction = (id: string) => loadingAction(IntegrationsConst.DEACTIVATE_INTEGRATION_LOADING, { id });

export const deactivateIntegrationErrorAction = (error: string) =>
  errorAction(IntegrationsConst.DEACTIVATE_INTEGRATION_ERROR, error, {
    id: undefined
  });

export const deactivateIntegrationSuccessAction = (data: DeactivateIntegrationSchema) => {
  const payload = { ...data, id: undefined, ...successSideEffectState };
  return {
    type: IntegrationsConst.DEACTIVATE_INTEGRATION_SUCCESS,
    payload
  };
};

/**
 * GET_INTEGRATION_CONFIG
 */
export interface IntegrationConfigSchema {
  CredRequiredParams: string[];
  HasDownwardMapping: false;
  MetaRequiredParams: string[];
}

export interface GetIntegrationConfigSchema extends SideEffectSchema, APIErrorResponseSchema {
  schema: ObjectSchema<IntegrationConfigSchema>;
}
export const getIntegrationConfigAction = () => {
  return {
    type: IntegrationsConst.GET_INTEGRATION_CONFIG
  };
};

export const getIntegrationConfigLoadingAction = () => loadingAction(IntegrationsConst.GET_INTEGRATION_CONFIG_LOADING);

export const getIntegrationConfigErrorAction = (error: string) => errorAction(IntegrationsConst.GET_INTEGRATION_CONFIG_ERROR, error);

export const getIntegrationConfigSuccessAction = (data: GetIntegrationConfigSchema) => {
  const payload = { ...data, ...successSideEffectState };
  return {
    type: IntegrationsConst.GET_INTEGRATION_CONFIG_SUCCESS,
    payload
  };
};

/**
 * SAVE_INTEGRATION_DATA
 */
export interface SaveIntegrationDataSchema extends SideEffectSchema, APIErrorResponseSchema {
  IsPosted: boolean;
}
export interface SaveIntegrationDataArgs {
  Id?: string;
  PluginFilters?: ObjectSchema<string>;
  Filter?: ObjectSchema<string>;
  Script?: string;
  DownwardMapping?: ObjectSchema<string> | null;
  IntegrationName: string;
  Event: string;
  ChangeEventTo?: string;
  IsEnable: boolean;
  IsActive: boolean;
  Mapping: ObjectSchema<string> | null;
  Credentials: ObjectSchema<string>;
  Meta: ObjectSchema<string>;
}
export const saveIntegrationDataAction = (payload: SaveIntegrationDataArgs) => {
  return {
    type: IntegrationsConst.SAVE_INTEGRATION_DATA,
    payload
  };
};

export const saveIntegrationDataLoadingAction = () => loadingAction(IntegrationsConst.SAVE_INTEGRATION_DATA_LOADING);

export const saveIntegrationDataErrorAction = (error: string) => errorAction(IntegrationsConst.SAVE_INTEGRATION_DATA_ERROR, error);

export const saveIntegrationDataSuccessAction = (data: SaveIntegrationDataSchema) => {
  const payload = { ...data, ...successSideEffectState };
  return {
    type: IntegrationsConst.SAVE_INTEGRATION_DATA_SUCCESS,
    payload
  };
};
//auditlog
export interface AuditLogConfigResponseSchema {
  _id?: string;
  description?: string;
  errorCode?: number;
  message?: string;
  Provider?: string;
  Endpoint?: string;
  IsSSLAuthEnabled?: boolean;
  RootCAPath?: string;
  ClientCertPath?: string;
  ClientPrivateKey?: string;
  Domain?: string;
  StorageCollection?: string;
  Credentials?: {
    Username?: string;
    Token?: string;
  };
}
export interface GetAuditLogConfigSchema extends SideEffectSchema {
  data?: AuditLogConfigResponseSchema[];
}
export interface SaveAuditLogConfigSchema extends SideEffectSchema {
  data?: any;
}
export interface ResetAuditLogConfigSchema extends SideEffectSchema {
  data?: any;
  IsDeleted?: boolean;
}

export interface AuditLogLimitsSchema extends SideEffectSchema {
  Total?: number;
  Used?: number;
}

export const getAuditLogLimitsAction = () => ({
  type: IntegrationsConst.GET_AUDIT_LOG_LIMITS,
  payload: {}
});

export const getAuditLogLimitsLoadingAction = () => loadingAction(IntegrationsConst.GET_AUDIT_LOG_LIMITS_LOADING);

export const getAuditLogLimitsSuccessAction = (data: { Total: number; Used: number }) => ({
  type: IntegrationsConst.GET_AUDIT_LOG_LIMITS_SUCCESS,
  payload: { ...data, ...successSideEffectState }
});
export const getAuditLogLimitsErrorAction = (error: string) => errorAction(IntegrationsConst.GET_AUDIT_LOG_LIMITS_ERROR, error);

export interface AuditLogBodySchema {
  description?: string;
  errorCode?: number;
  message?: string;
  Provider?: string;
  Endpoint?: string;
  IsSSLAuthEnabled?: boolean;
  RootCAPath?: string;
  ClientCertPath?: string;
  ClientPrivateKey?: string;
  Domain?: string;
  StorageCollection?: string;
  Credentials?: {
    Username?: string;
    Token?: string;
    Password?: string;
  };
}
